import Sdk from '@/sdk';

export default {
    namespaced: true,
    state: {},
    getters: {},
    actions: {
        preProcessForm(__, file) {
            const url = file instanceof File ? URL.createObjectURL(file) : file;
            return new Sdk.FormData({ url }, [{
                urls: [url],
                ext: (mimetype) => ({
                    'image/png': 'png',
                    'image/jpeg': 'jpg',
                }[mimetype] || 'png'),
            }]);
        },
        async create({ dispatch }, file) {
            const form = await dispatch('preProcessForm', file);
            const res = await Sdk.Image.PrivateCreateResource(form, {
                params: { 'return-full': true },
            });
            return res.data?.url;
        },
    },
};
